export const EnumToArray = (enumType: any) => {
  let arrayEnum: Array<{ key: string; value: string }> = [];
  Object.keys(enumType).forEach((key) => arrayEnum.push({ key: key, value: enumType[key] }));
  return arrayEnum;
};

export const OrderArrayByNumberKey = (array: any, key: any) => {
  array.sort(function (a: any, b: any) {
    if (Number(a[key]) > Number(b[key])) {
      return 1;
    }
    if (Number(a[key]) < Number(b[key])) {
      return -1;
    }
    return 0;
  });
};
